export const NO_AXIS_SELECTED_VALUE = '';
